import { render, staticRenderFns } from "./3-member-profile-extras.vue?vue&type=template&id=282f0a95&scoped=true"
import script from "./3-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./3-member-profile-extras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f0a95",
  null
  
)

export default component.exports